import type { LocaleSetting, LocaleType } from '#/config'

export const LOCALE: { [key: string]: LocaleType } = {
  ZH_TW: 'zh_TW',
  EN_US: 'en',
}

export const localeSetting: LocaleSetting = {
  // Locale
  locale: LOCALE.ZH_TW,
  // Default locale
  fallback: LOCALE.ZH_TW,
  // available Locales
  availableLocales: [LOCALE.ZH_TW, LOCALE.EN_US],
}
